import linepushAuth from './linepushAuth'
import linepush from './linepush'
import pushns from './pushns'
import lineLogin from './lineLogin'
const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    linepushAuth,
    linepush,
    pushns,
    lineLogin,
  }
}
